import React from 'react';

import { ConnectedExplorer } from '~src/spacesPlatform/components/Explorer/ConnectedExplorer';
import { CreateContentButtonLocations } from '~src/spacesPlatform/components/Explorer/CreateContent/CreateContentButton';
import { PropsForExplorerToolbar } from '~src/spacesPlatform/components/Explorer/Explorer';
import { ConnectedExplorerSubspaceInitializer } from '~src/spacesPlatform/components/Explorer/helpers/ExplorerSubspaceInitializer';
import { ConnectedSpaceInfoProvider } from '~src/spacesPlatform/components/Explorer/helpers/SpaceInfoProvider';
import { createContentButton } from '~src/spacesPlatform/components/spaceComponents/SubspaceHelpers';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '~src/spacesPlatform/state/SpaceInfo';
import { SpaceContainerStyles } from '~src/spacesPlatform/style/SpaceContainerStyles';
import { newWorkbookButton } from '~src/userManagement/users/components/siteUserSpace/SiteSpaceHeaderButtons';

import { ConnectedQueryParamUpdateProvider } from '../app/spaces/RouterHelpers/QueryParamUpdateProvider';
import { ExplorableItemDefinition } from '../contentDefinitionInterfaces/ContentDefinitionsTypes';
import { IContentType } from '../spacesPlatform/models/ContentTypes';
import { FeatureFlags } from '../ts/FeatureFlags';
import { CatalogContentType } from './CatalogContentType';

export interface CatalogBrowserSubspaceExplorerProps {
  readonly subspaceName: CatalogContentType;
  readonly routeLocationSearch: string;
  readonly contentDefinition: ExplorableItemDefinition;
  readonly contentType: IContentType;
}

export function CatalogBrowserSubspaceExplorer(props: CatalogBrowserSubspaceExplorerProps): JSX.Element {

  const queryUpdaterProps = {
    routeLocationPath: '',
    routeLocationSearch: props.routeLocationSearch,
    shouldUpdateContentTypes: true,
    shouldUpdateFilters: true,
    shouldUpdateBreadcrumbs: false, // Breadcrumbs are updated by the DC3 code
    shouldUpdateSort: true
  };

  const spaceInfo: SpaceInfo = {
    item: SpaceItemForNonEntitySpace,
    spaceType: 'catalog',
    subspaceName: props.subspaceName,
  };

  const baseToolbarProps: PropsForExplorerToolbar = {
    supportFilterPanel: props.contentType.canShowFilterPanel,
    toolbarVisibility: 'enabled',
  };

  const createButton = FeatureFlags.flowsFromCatalogEnabled ?
      createContentButton({ location: CreateContentButtonLocations.ExternalAssets, spaceType: 'externalAssets'}) : newWorkbookButton();

  return (
    <div className={SpaceContainerStyles.SubplaceArea}>
      <ConnectedSpaceInfoProvider spaceInfo={spaceInfo}>
        <ConnectedQueryParamUpdateProvider {...queryUpdaterProps}>
          <ConnectedExplorerSubspaceInitializer routeLocationSearch={props.routeLocationSearch} spaceInfo={spaceInfo}>
            <ConnectedExplorer
              supportedDisplayModes={props.contentDefinition.supportedDisplayModes}
              toolbarProps={{...baseToolbarProps, toolbarContentSpecificControls: { beginning: createButton }}}
            />
          </ConnectedExplorerSubspaceInitializer>
        </ConnectedQueryParamUpdateProvider>
      </ConnectedSpaceInfoProvider>
    </div>
  );
}
